<!-- DDCFB New File-->
<section class="user-accounts user-accounts-background">
  <img
    *ngIf="!fromLogin"
    alt=""
    class="user-accounts-background-image"
    src="{{ switchingAccountService?.initialBusinessType?.acPickerLogo }}"
  />
  <div
    [ngClass]="{ chooseProfileHeader: !fromLogin }"
    class="padding-row account-header"
  >
    <h4 class="OneLinkNoTx">
      {{ businesschooseAccountDisplayText + ', ' + loggedInUser?.firstName }}
    </h4>
    <p [innerHTML]="businessChooseAccountDisclaimer"></p>
  </div>
  <div class="companyNameSection">
    <div
      (click)="selectePersonalAccount()"
      (keypress)="selectPersonalOnEnter($event)"
      class="logged-user-section personalInfo"
    >
      <div class="row">
        <a href="javascript:void(0)">
          <span
            attr.aria-label="{{
              personalTravelerDisplayText + ' ' + 'redirects to Home page'
            }}"
          >
            <span aria-hidden="true" class="name">
              {{ personalTravelerDisplayText }}
            </span>
          </span>
        </a>
        <span *ngIf="!fromLogin && personalSelected" class="selected"></span>
        <span class="type-list-arrow ml-auto"></span>
      </div>
    </div>
    <div class="business-accounts companyInfo OneLinkNoTx">
      <div class="companyName">
        <span class="type">{{ businessTravelTextDisplay }}</span>
      </div>
      <div
        (click)="selectAccount($event, account, false)"
        (keypress)="selectBusinessOnEnter($event, account)"
        *ngFor="let account of displayBizAccounts"
        class="row companyNameBotton"
      >
        <a href="javascript:void(0)">
          <span
            attr.aria-label="{{
              account.trimmedBusinessName.toUpperCase() +
                ' ' +
                businessTravelTextDisplay
            }}"
          >
            <span aria-hidden="true" class="name">
              {{ account.trimmedBusinessName }}
            </span>
            <span
              *ngIf="account.isOaSmeAccount"
              aria-hidden="true"
              class="name"
            >
              {{ account.corporateAgreementId }}
            </span>
          </span>
        </a>
        <span *ngIf="!fromLogin && account.selected" class="selected"></span>
        <span
          [ngClass]="{ 'mt-2': account.isOaSmeAccount }"
          class="type-list-arrow ml-auto"
        ></span>
      </div>
    </div>

    <div
      *ngIf="isBusinessAdmin"
      class="business-accounts adminInfo OneLinkNoTx"
    >
      <div class="adminCompanyName">
        <span class="type">{{ adminTextDisplay }}</span>
      </div>
      <div *ngFor="let account of displayBizAccounts">
        <div
          (click)="selectAdmin($event, account)"
          (keypress)="selectAdminOnEnter($event, account)"
          *ngIf="account.isAdmin"
          class="row companyNameBotton"
        >
          <a href="javascript:void(0)">
            <span
              attr.aria-label="{{
                account.adminBizName.toUpperCase() +
                  ' ' +
                  adminTextDisplay +
                  ' ' +
                  'Opens in a new window'
              }}"
            >
              <span aria-hidden="true" class="name">
                {{ account.adminBizName }}
              </span>
            </span>
          </a>
          <span class="type-list-arrow ml-auto"></span>
        </div>
      </div>
    </div>
  </div>
  <div
    [innerHTML]="learnMoreText"
    [ngClass]="{ bottomPaddingForLoginPicker: fromLogin }"
    class="learnMore"
  ></div>
  <div *ngIf="!fromLogin" class="accnt-picker-bg logoutdivContainer">
    <a
      #logoutLink
      (click)="
        removeCookieAndLogout(
          switchingAccountService.initialBusinessType.businessLogoutUrl
        )
      "
      class="logoutlink"
      href="#"
      id="logoutLink"
      role="button"
    >
      {{ switchingAccountService?.initialBusinessType?.logOutDisplayText }}
    </a>
  </div>
</section>
